import React from 'react';
import { TrendingUp, TrendingDown, Activity } from 'lucide-react';

const Tile = ({ label, children, testId }) => (
  <div className="bg-gray-50 rounded p-3" data-testid={testId}>
    <div className="text-xs text-gray-500">{label}</div>
    <div className="font-semibold flex items-center gap-1">{children}</div>
  </div>
);

const TrendIcon = ({ trend }) => {
  if (trend === 'uptrend') return <TrendingUp size={16} className="text-green-600" />;
  if (trend === 'downtrend') return <TrendingDown size={16} className="text-red-600" />;
  return <Activity size={16} className="text-gray-500" />;
};

const trendCls = (trend) => {
  if (trend === 'uptrend') return 'text-green-600';
  if (trend === 'downtrend') return 'text-red-600';
  return '';
};

const rsiCls = (rsi) => {
  if ((rsi || 0) >= 70) return 'text-red-600';
  if ((rsi || 0) <= 30) return 'text-green-600';
  return '';
};

const ChartIndicatorStrip = ({ indicators }) => {
  const ind = indicators || {};
  const ret = ind.totalReturnPct || 0;
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-4">
      <Tile label="Trend" testId="chart-indicator-trend">
        <TrendIcon trend={ind.trend} />
        <span className={trendCls(ind.trend)}>{ind.trend}</span>
      </Tile>
      <Tile label="Period Return">
        <span className={ret >= 0 ? 'text-green-600' : 'text-red-600'}>
          {ret >= 0 ? '+' : ''}
          {ind.totalReturnPct?.toFixed(2)}%
        </span>
      </Tile>
      <Tile label="RSI(14)">
        <span className={rsiCls(ind.rsi)}>{ind.rsi?.toFixed(1) ?? '—'}</span>
      </Tile>
      <Tile label="Support">${ind.support}</Tile>
      <Tile label="Resistance">${ind.resistance}</Tile>
    </div>
  );
};

export default ChartIndicatorStrip;
